<template>
  <el-dialog
    :title="$t('repairSetting.addTitle')"
    :visible.sync="visible"
    width="650px"
    custom-class="repair-design-dialog"
    @close="closeDialog"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="114px" class="repair-design-form">
      <el-form-item :label="$t('repairSetting.community')" prop="communityId">
        <el-select v-model="formData.communityId" :placeholder="$t('repairSetting.selectPlaceholder')" filterable>
          <el-option v-for="item in communityList" :key="item.communityId" :label="item.name" :value="item.communityId" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.settingType')" prop="repairSettingType">
        <el-select v-model="formData.repairSettingType" :placeholder="$t('repairSetting.selectPlaceholder')">
          <el-option :label="$t('repairSetting.cleaningOrder')" value="100" />
          <el-option :label="$t('repairSetting.repairOrder')" value="200" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.typeName')" prop="repairTypeName">
        <el-input v-model="formData.repairTypeName" :placeholder="$t('repairSetting.inputPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('repairSetting.area')" prop="publicArea">
        <el-select v-model="formData.publicArea" :placeholder="$t('repairSetting.selectPlaceholder')">
          <el-option :label="$t('repairSetting.nonHouse')" value="T" />
          <el-option :label="$t('repairSetting.house')" value="F" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.dispatchMethod')" prop="repairWay">
        <el-select v-model="formData.repairWay" :placeholder="$t('repairSetting.selectPlaceholder')">
          <el-option :label="$t('repairSetting.grabOrder')" value="100" />
          <el-option :label="$t('repairSetting.assign')" value="200" />
          <el-option :label="$t('repairSetting.polling')" value="300" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.ownerDisplay')" prop="isShow">
        <el-select v-model="formData.isShow" :placeholder="$t('repairSetting.selectPlaceholder')">
          <el-option :label="$t('repairSetting.yes')" value="Y" />
          <el-option :label="$t('repairSetting.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.notificationMethod')" prop="notifyWay">
        <el-select v-model="formData.notifyWay" :placeholder="$t('repairSetting.selectPlaceholder')">
          <el-option :label="$t('repairSetting.sms')" value="SMS" />
          <el-option :label="$t('repairSetting.wechat')" value="WECHAT" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.processingTime')" prop="doTime">
        <el-input v-model.number="formData.doTime" type="number" :placeholder="$t('repairSetting.inputPlaceholder')">
          <template slot="append">{{ $t('repairSetting.processingTimeUnit') }}</template>
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.timeoutWarning')" prop="warningTime">
        <el-input v-model.number="formData.warningTime" type="number" :placeholder="$t('repairSetting.inputPlaceholder')">
          <template slot="append">{{ $t('repairSetting.timeoutWarningUnit') }}</template>
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.returnVisitSetting')" prop="returnVisitFlag">
        <el-select v-model="formData.returnVisitFlag" :placeholder="$t('repairSetting.selectPlaceholder')">
          <el-option :label="$t('repairSetting.noFollowUp')" value="001" />
          <el-option :label="$t('repairSetting.followUp')" value="003" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('repairSetting.explanation')" prop="remark">
        <el-input v-model="formData.remark" :placeholder="$t('repairSetting.inputPlaceholder')" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('repairSetting.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('repairSetting.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRepairSetting } from '@/api/work/repairSettingApi'
import { getCommunityId } from '@/api/community/communityApi'
import { listCommunitys } from '@/api/community/communityManageApi'

export default {
  name: 'AddRepairSetting',
  data() {
    return {
      visible: false,
      communityList: [],
      formData: this.getDefaultFormData(),
      rules: {
        communityId: [
          { required: true, message: this.$t('repairSetting.communityRequired'), trigger: 'change' }
        ],
        repairSettingType: [
          { required: true, message: this.$t('repairSetting.settingTypeRequired'), trigger: 'change' }
        ],
        repairTypeName: [
          { required: true, message: this.$t('repairSetting.repairTypeNamePlaceholder'), trigger: 'blur' }
        ],
        publicArea: [
          { required: true, message: this.$t('repairSetting.publicAreaRequired'), trigger: 'change' }
        ],
        repairWay: [
          { required: true, message: this.$t('repairSetting.dispatchMethodRequired'), trigger: 'change' }
        ],
        isShow: [
          { required: true, message: this.$t('repairSetting.ownerDisplayRequired'), trigger: 'change' }
        ],
        notifyWay: [
          { required: true, message: this.$t('repairSetting.notificationMethodRequired'), trigger: 'change' }
        ],
        returnVisitFlag: [
          { required: true, message: this.$t('repairSetting.returnVisitRequired'), trigger: 'change' }
        ],
        doTime: [
          { required: true, message: this.$t('repairSetting.processingTimeRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('repairSetting.processingTimeMin'), trigger: 'blur' }
        ],
        warningTime: [
          { required: true, message: this.$t('repairSetting.timeoutWarningRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('repairSetting.timeoutWarningMin'), trigger: 'blur' }
        ],
        remark: [
          { max: 500, message: this.$t('repairSetting.remarkMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    getDefaultFormData() {
      const communityId = getCommunityId()
      return {
        communityId: communityId && communityId !== '-1' ? communityId : '',
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT'
      }
    },

    async open() {
      await this.loadCommunityList()
      this.formData = this.getDefaultFormData()
      this.visible = true
    },

    async loadCommunityList() {
      try {
        const res = await listCommunitys({ page: 1, row: 1000 })
        this.communityList = (res.communitys || res.data || []).map(item => ({
          ...item,
          communityId: String(item.communityId)
        })).filter(item => item.communityId && item.communityId !== '-1')
      } catch (error) {
        console.error('加载小区列表失败:', error)
        this.communityList = []
      }
    },

    closeDialog() {
      this.visible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = this.getDefaultFormData()
    },

    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveRepairSetting(this.formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.$emit('success')
            this.closeDialog()
          } catch (error) {
            console.error('添加报修设置失败:', error)
            this.$message.error(this.$t('repairSetting.addFailed'))
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.repair-design-dialog {
  height: 802px;
  max-height: calc(100vh - 80px);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-top: 40px !important;

  .el-dialog__header {
    flex: 0 0 66px;
    height: 66px;
    padding: 0 24px;
    background: #ebf2fa;
    border-bottom: 1px solid #dce6f5;
    box-sizing: border-box;
    line-height: 66px;
  }

  .el-dialog__title {
    color: #1d2129;
    font-size: 16px;
    font-weight: 600;
  }

  .el-dialog__headerbtn {
    top: 23px;
    right: 24px;
  }

  .el-dialog__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 24px 24px 12px;
    box-sizing: border-box;
  }

  .el-dialog__footer {
    flex: 0 0 auto;
    padding: 24px 24px 28px;
    box-sizing: border-box;
    border-top: 1px solid #dce6f5;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .el-button {
    min-width: 98px;
    height: 38px;
    border-radius: 10px;
    font-size: 14px;
  }

  .el-button--default {
    color: #0e76ff;
    border-color: #0e76ff;
  }

  .el-button--primary {
    background: #0e76ff;
    border-color: #0e76ff;
  }
}

.repair-design-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item:nth-child(1) {
    margin-bottom: 13px;
  }

  .el-form-item:nth-child(2) {
    margin-bottom: 19px;
  }

  .el-form-item:nth-child(3),
  .el-form-item:nth-child(4) {
    margin-bottom: 18px;
  }

  .el-form-item:nth-child(5) {
    margin-bottom: 26px;
  }

  .el-form-item:nth-child(6),
  .el-form-item:nth-child(7) {
    margin-bottom: 22px;
  }

  .el-form-item:nth-child(8) {
    margin-bottom: 26px;
  }

  .el-form-item:nth-child(9) {
    margin-bottom: 18px;
  }

  .el-form-item:nth-child(10) {
    margin-bottom: 20px;
  }

  .el-form-item__label {
    color: #1d2129;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    padding-right: 14px;
  }

  .el-form-item__label::after {
    content: ':';
    color: #000;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
    margin-right: 4px;
  }

  .el-form-item__content {
    line-height: 38px;
  }

  .el-input__inner,
  .el-textarea__inner {
    height: 38px;
    border-color: #dce6f5;
    border-radius: 10px;
    color: #1d2129;
    font-size: 14px;
  }

  .el-select,
  .el-date-editor.el-input {
    width: 100%;
  }

  .el-input-group__append {
    width: 44px;
    padding: 0;
    color: #364153;
    background: #fff;
    border-color: #dce6f5;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
</style>
